import {USER_LOGGED_OUT} from "../../user/constants/actionTypes";
import {
  MESSAGE_ACCEPT,
  MESSAGE_FINISH,
  MESSAGE_FINISH_ALL,
  MESSAGE_HISTORY,
  MESSAGE_MISS,
  MESSAGE_RECEIVE,
  MESSAGE_REPLY_NOTIFICATION,
  MESSAGE_SEND,
  MESSAGE_START,
  MESSAGE_TYPING,
  MESSAGE_TYPING_START,
  MESSAGE_TYPING_STOP
} from "../constants/actionTypes";
import {MESSAGE_TYPE_RECEIVE, MESSAGE_TYPE_SEND} from "../constants";
import {
  RC_CLOSE,
  RC_MESSAGE_ALL,
  RC_MESSAGE_NEW,
  RC_MESSAGE_UNREAD,
  RC_OPEN
} from "../../../shared/modules/rocketChat/constants/actionTypes";
import {TW_VIDEO_TAG} from "../../../shared/modules/twilio/constants";

const defaultState = {
  items: {},
  missed: {},
  text: "",
  user: "",
  isOnline: false,
  isTyping: false
};

export const messageReducer = (state = defaultState, action) => {
  switch (action.type) {
    case USER_LOGGED_OUT:
      return defaultState;
    case MESSAGE_SEND:
      return {
        ...state,
        user: action.user,
        text: "",
        items: {
          ...state.items || {},
          [action.room]: [
            ...state.items[action.room] || [],
            {
              text: action.message,
              time: new Date(),
              type: MESSAGE_TYPE_SEND,
              confirmed: false
            }
          ]
        }
      };
    case RC_MESSAGE_NEW:
    case MESSAGE_RECEIVE:
      return {
        ...state,
        items: {
          ...state.items,
          [action.message.rid]: (state.items[action.message.rid] || []).map((item) => {
            return item.type === MESSAGE_TYPE_SEND &&
            !item.confirmed &&
            item.text === action.message.msg &&
            action.message.u.username === action.user
              ? {
                ...item,
                id: action.message._id,
                confirmed: true
              }
              : item
          }).concat(
            (state.items[action.message.rid] || [])
              .find((item) => {
                return item.type === MESSAGE_TYPE_SEND &&
                  item.text === action.message.msg
              })
            ? []
            : [
              {
                type: action.message.u.username === action.user
                  ? MESSAGE_TYPE_SEND
                  : MESSAGE_TYPE_RECEIVE,
                text: action.message.msg,
                time: new Date(action.message.ts.$date),
                id: action.message._id,
                confirmed: true
              }
            ]
          )
        }
      };
    case MESSAGE_TYPING:
      return {
        ...state,
        text: action.text
      };
    case MESSAGE_REPLY_NOTIFICATION:
      return {
        ...state,
        text: action.text,
        user: action.user
      };
    case MESSAGE_TYPING_START:
      return {
        ...state,
        isTyping: true
      };
    case MESSAGE_TYPING_STOP:
      return {
        ...state,
        isTyping: false
      };
    case MESSAGE_FINISH:
    case MESSAGE_FINISH_ALL:
      return {
        ...state,
        user: "",
        text: ""
      };
    case MESSAGE_HISTORY:
    case RC_MESSAGE_ALL:
      return {
        ...state,
        items: action.messages.reverse().reduce((messages, messagesItem) => {
          if (action.unreadNotLoaded === 0) {
            messages[messagesItem.rid] = messages[messagesItem.rid] || [];
            if (!messages[messagesItem.rid].find((element) => {
              return element.id === messagesItem._id;
            })) {
              messages[messagesItem.rid].push(
                {
                  type: action.user.username === messagesItem.u.username
                    ? MESSAGE_TYPE_SEND
                    : MESSAGE_TYPE_RECEIVE,
                  text: messagesItem.msg,
                  time: new Date(messagesItem.ts.$date),
                  id: messagesItem._id,
                  confirmed: true
                }
              );
            }
          }
          return messages;
        }, {...state.items})
      };
    case MESSAGE_START:
    case MESSAGE_ACCEPT:
      return {
        ...state,
        missed: {
          ...state.missed,
          [action.user]: 0
        },
        user: action.user
      };
    case MESSAGE_MISS:
      return {
        ...state,
        missed: {
          ...state.missed,
          [action.user]: (state.missed[action.user] || 0) + 1
        }
      };
    case RC_MESSAGE_UNREAD:
      return {
        ...state,
        missed: {
          ...state.missed,
          [action.room.name]: action.messages.reduce((missed, message) => {
            return message.msg.startsWith(TW_VIDEO_TAG)
              ? missed
              : missed + 1;
          }, 0)
        }
      };
    case RC_OPEN:
      return {
        ...state,
        isOnline: true
      };
    case RC_CLOSE:
      return {
        ...state,
        isOnline: false
      };
    default:
      return state;
  }
};
